const state = {

    JobListings : [],
    AppliedJobs : []
    
  }
  
  const mutations = {
    SetJobListings(state, payload){
        state.JobListings = payload
    },
    SetIndividualJobListing(state, payload){
        state.JobListings.push(payload)
    },
    UpdateIndividualJobListing(state, payload){

        let index = state['JobListings'].findIndex(x => x["_id"] == payload["_id"])
        state['JobListings'].splice(index,1,payload)
    },
    DeleteIndividualJobListing(state, payload){

        let index = state['JobListings'].findIndex(x => x["_id"] == payload["Listing_Id"])
        state['JobListings'].splice(index,1)
    },
    SetAppliedJobs(state, payload){
      state.AppliedJobs = payload
    },
    SetIndividualAppliedJobs(state, payload){
        state.AppliedJobs.push(payload)
    },
    UpdateIndividualAppliedJobs(state, payload){

        let index = state['AppliedJobs'].findIndex(x => x["_id"] == payload["_id"])
        state['AppliedJobs'].splice(index,1,payload)
    },
    DeleteIndividualAppliedJobs(state, payload){

        let index = state['AppliedJobs'].findIndex(x => x["_id"] == payload["Listing_Id"])
        state['AppliedJobs'].splice(index,1)
    }

  }
  
  const actions = {
    
  }
  
  const getters = {

    GetJobListings(state){

        return state.JobListings
    },
    GetAppliedJobs(state){
      return state.AppliedJobs
    }
  }
  
  export default {
    state,
    mutations,
    actions,
    getters
  }
  